import { SamplesProvider } from 'contexts/SamplesContext.js';
import { RouterProvider } from 'react-router';
import router from 'routes/index.js';

export default function App() {
  return (
    <SamplesProvider>
      <RouterProvider router={router} />
    </SamplesProvider>
  );
}
